// extracted by mini-css-extract-plugin
export default {"TableView":"StockTable_TableView__8xZW0","Cell":"StockTable_Cell__Z+Pjo","Paper":"StockTable_Paper__NZ00p"};